import NetworkingTableContainer from "./NetworkingTable.container";
import NetworkingTable from "./NetworkingTable";

export default NetworkingTableContainer;
export { NetworkingTable };
